export default __webpack_public_path__ + "static/media/Main-Page-Chart.f03ffbea.png";